<div style="background:#FFFFFF;">
    <header>
        <app-header></app-header>
    </header>
    <app-spinner-component></app-spinner-component>
    <router-outlet></router-outlet>
</div>
<!-- <div style="height:20px;"></div> -->
<footer style="z-index: 11 !important">
    <app-footer></app-footer>
</footer>